import { combineReducers } from 'redux'
import {
  ACTION_PAGE_ERROR, ACTION_PAGE_LOADING, ACTION_PAGE_SUCCESS,
  ACTION_VIEW_SUCCESS, ACTION_VIEW_LOADING, ACTION_VIEW_ERROR,
  ACTION_LIST_ERROR, ACTION_LIST_LOADING, ACTION_LIST_SUCCESS,
} from './constant'

const actionPageError = (state = false, action) => {
  switch (action.type) {
    case ACTION_PAGE_ERROR:
      return action.actionPageError
    default:
      return state
  }
}

const actionPageLoading = (state = false, action) => {
  switch (action.type) {
    case ACTION_PAGE_LOADING:
      return action.actionPageLoading
    default:
      return state
  }
}

const actionPageSuccess = (state = false, action) => {
  switch (action.type) {
    case ACTION_PAGE_SUCCESS:
      return action.actionPageSuccess
    default:
      return state
  }
}

const actions = (state = [], action) => {
  switch (action.type) {
    case ACTION_PAGE_SUCCESS:
      return action.action
    case ACTION_LIST_SUCCESS:
      return action.action
    default:
      return state
  }
}

const action = (state = [], action) => {
  switch (action.type) {
    case ACTION_VIEW_SUCCESS:
      return action.action
    default:
      return state
  }
}

const actionViewError = (state = false, action) => {
  switch (action.type) {
    case ACTION_VIEW_ERROR:
      return action.actionViewError
    default:
      return state
  }
}

const actionViewLoading = (state = false, action) => {
  switch (action.type) {
    case ACTION_VIEW_LOADING:
      return action.actionViewLoading
    default:
      return state
  }
}

const actionViewSuccess = (state = false, action) => {
  switch (action.type) {
    case ACTION_VIEW_SUCCESS:
      return action.actionViewSuccess
    default:
      return state
  }
}

const actionListError = (state = false, action) => {
  switch (action.type) {
    case ACTION_LIST_ERROR:
      return action.actionListError
    default:
      return state
  }
}

const actionListLoading = (state = false, action) => {
  switch (action.type) {
    case ACTION_LIST_LOADING:
      return action.actionListLoading
    default:
      return state
  }
}

const actionListSuccess = (state = false, action) => {
  switch (action.type) {
    case ACTION_LIST_SUCCESS:
      return action.actionListSuccess
    default:
      return state
  }
}

const actionReducer = combineReducers({
  actionPageError,
  actionPageLoading,
  actionPageSuccess,

  actions,

  actionViewError,
  actionViewLoading,
  actionViewSuccess,

  actionListError,
  actionListLoading,
  actionListSuccess,
})

export default actionReducer
